// import { IconSvgProps } from "../types";

export const LeftLines = ({}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="223"
        height="109"
        viewBox="0 0 223 109"
        fill="none"
    >
        <path
            d="M162.5 2.26566e-05L-57 6.10352e-05L-57 19.0001L162.5 19C167.747 19 172 14.7467 172 9.50002C172 4.25332 167.747 2.17392e-05 162.5 2.26566e-05Z"
            fill="url(#paint0_linear_99_2551)"
        />
        <path
            d="M79.5 64.0001L213.5 64.0001C218.747 64.0001 223 59.7468 223 54.5001C223 49.2533 218.747 45 213.5 45L79.5 45.0001C74.2533 45.0001 70 49.2534 70 54.5001C70 59.7468 74.2533 64.0001 79.5 64.0001Z"
            fill="url(#paint1_linear_99_2551)"
        />
        <path
            d="M118.5 90.0001H-12V109H118.5C123.747 109 128 104.747 128 99.5001C128 94.2534 123.747 90.0001 118.5 90.0001Z"
            fill="url(#paint2_linear_99_2551)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_99_2551"
                x1="-57"
                y1="9.50006"
                x2="172"
                y2="9.50002"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" stopOpacity="0.77" />
                <stop offset="0.519737" stopColor="white" stopOpacity="0.25" />
                <stop offset="1" stopColor="white" stopOpacity="0.73" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_99_2551"
                x1="223"
                y1="54.5001"
                x2="70"
                y2="54.5001"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C9F2FF" />
                <stop
                    offset="0.557292"
                    stopColor="#C9F2FF"
                    stopOpacity="0.54"
                />
                <stop offset="0.9999" stopColor="#C9F2FF" stopOpacity="0.16" />
                <stop offset="1" stopColor="#C9F2FF" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_99_2551"
                x1="-12"
                y1="99.5001"
                x2="128"
                y2="99.5001"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#EAE6FF" stopOpacity="0" />
                <stop
                    offset="0.0001"
                    stopColor="#F1F3FF"
                    stopOpacity="0.290176"
                />
                <stop
                    offset="0.265625"
                    stopColor="#EFEFFF"
                    stopOpacity="0.505208"
                />
                <stop offset="0.890625" stopColor="#EAE6FF" />
            </linearGradient>
        </defs>
    </svg>
);
